// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
  ComponentNameEnum,
  TextAlignValueEnum,
  AppearEffectEnum,
  VoucherIconListEnum,
  StepperSignEnum,
  TemplateStructureEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
import variables from '@/components/template-builder/utils/variables-list';
// eslint-disable-next-line import/no-cycle
import {
  setAnimated,
  setClass,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setCssPropertyWithImportant,
  setMediaDisplay, setVoucherIconClass,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getClassByName,
  getContent,
  getCssPropertyByName,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import {
  showButton,
  switchVoucherButtonAndCode,
} from '@/components/template-builder/callbacks';

// eslint-disable-next-line import/no-cycle
import setContent from '@/components/template-builder/setters/voucher';

// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import fontFieldConfig from '@/components/template-builder/config/fields/font-config';
// eslint-disable-next-line import/no-cycle
import getTextAlignFieldConfig from '@/components/template-builder/config/fields/text-align-config';
// eslint-disable-next-line import/no-cycle
import fontSizeFieldConfig from '@/components/template-builder/config/fields/font-size-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import textStylesFieldConfig from '@/components/template-builder/config/fields/text-styles-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getTriggerButtonFieldConfig from '@/components/template-builder/config/fields/trigger-button-config';
// eslint-disable-next-line import/no-cycle
import getInputVariablesFieldConfig from '@/components/template-builder/config/fields/input-variables-config';
// eslint-disable-next-line import/no-cycle
import getDropdownFieldConfig from '@/components/template-builder/config/fields/dropdown-config';
// eslint-disable-next-line import/no-cycle
import getWidthFieldConfig from '@/components/template-builder/config/fields/width-config';
// eslint-disable-next-line import/no-cycle
import getElementAlignFieldConfig from '@/components/template-builder/config/fields/element-align-config';
// eslint-disable-next-line import/no-cycle
import getBorderRadiusFieldConfig from '@/components/template-builder/config/fields/border-radius-config';
// eslint-disable-next-line import/no-cycle
import getIconsFieldConfig from '@/components/template-builder/config/fields/icons-config';
// eslint-disable-next-line import/no-cycle
import getStepperFieldConfig from '@/components/template-builder/config/fields/stepper-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '../../utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '../../utils/constants';

const widgetVoucherConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.voucher',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: '',
        selector: 'body #spm_body #{ID}',
        isNotCollapsible: true,
        items: [
          {
            label: 'templateBuilder.fields.voucherCodeDisplay',
            selector: '{SELECTOR} .spm_generate_voucher_button',
            properties: [],
            ...getTriggerButtonFieldConfig('templateBuilder.fields.showCode', 'templateBuilder.fields.hideCode', switchVoucherButtonAndCode, showButton),
          },
        ],
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.buttonConfiguration',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.buttonText',
                  selector: '{SELECTOR} .spm_container_voucher_button a.spm_button',
                  properties: [{ name: 'content', getter: getContent, setters: [setContent] }],
                  ...getInputVariablesFieldConfig('Texte du bouton', variables.allVariables, false, true),
                },
                {
                  label: 'templateBuilder.fields.appearEffect',
                  selector: '{SELECTOR} .spm_container_voucher_button',
                  properties: [{ name: 'spmEffect_', getter: getClassByName, setters: [setClass, setAnimated] }],
                  ...getDropdownFieldConfig(Object.values(AppearEffectEnum).map((effect) => ({ label: effect, value: effect })), AppearEffectEnum.NONE),
                },
                {
                  label: 'templateBuilder.fields.voucherIcon',
                  selector: '{SELECTOR} .spm_container_voucher_button .spm_voucher_icon',
                  properties: [{ name: 'spm_icon-', getter: getClassByName, setters: [setVoucherIconClass] }],
                  ...getIconsFieldConfig(Object.values(VoucherIconListEnum), 'spm_icon-', 'hidden'),
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.codeConfiguration',
              selector: 'body #spm_body #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.appearEffect',
                  selector: '{SELECTOR} .spm_container_voucher_code',
                  properties: [{ name: 'spmEffect_', getter: getClassByName, setters: [setClass, setAnimated] }],
                  ...getDropdownFieldConfig(Object.values(AppearEffectEnum).map((effect) => ({ label: effect, value: effect })), AppearEffectEnum.NONE),
                },
                {
                  label: 'templateBuilder.fields.voucherIcon',
                  selector: '{SELECTOR} .spm_container_voucher_code .spm_voucher_icon_code',
                  properties: [{ name: 'spm_icon-', getter: getClassByName, setters: [setClass] }],
                  ...getIconsFieldConfig(Object.values(VoucherIconListEnum), 'spm_icon-', 'hidden'),
                },

              ],
            },
          ],
        },
      },
      {
        type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
        tabItemType: TemplateStructureEnum.GROUP,
        label: 'templateBuilder.configs.widgetStyles',
        tabPanel: {
          items: [
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.voucherButtonStyles',
              selector: 'body #spm_body #spm_content #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.iconColor',
                  selector: '{SELECTOR} .spm_voucher_icon, {SELECTOR} .spm_voucher_icon_code',
                  properties: [{ name: 'color', getter: getCssPropertyByName, setters: [setCssPropertyWithImportant] }],
                  ...getColorFieldConfig('#333333'),
                },
                {
                  label: 'templateBuilder.fields.buttonWidth',
                  selector: '{SELECTOR} .spm_generate_voucher_button',
                  properties: [{ name: 'width', getter: getCssPropertyByName, setters: [setCssProperty] }],
                  ...getWidthFieldConfig(100),
                },
                {
                  label: 'templateBuilder.fields.buttonAlignment',
                  selector: '{SELECTOR} .spm_generate_voucher_button, {SELECTOR} .spm_container_voucher_code',
                  properties: [{ name: 'spm_div_align_', getter: getClassByName, setters: [setClass] }],
                  ...getElementAlignFieldConfig('spm_div_align_'),
                },
                {
                  label: 'templateBuilder.fields.contours',
                  selector: '{SELECTOR} a.spm_button',
                  properties: [{ name: 'border-radius', getter: getCssPropertyByName, setters: [setCssProperty] }],
                  ...getBorderRadiusFieldConfig('5px'),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
                  ],
                  ...bordersFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.buttonBackgroundColor',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [{
                    name: 'background',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getColorFieldConfig('#ECECEC', false, true),
                },
                {
                  label: 'templateBuilder.fields.font',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [
                    { name: 'font-family', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'color', getter: getCssPropertyByName, setters: [setCssPropertyWithImportant] },
                  ],
                  ...fontFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.contentAlignment',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [{ name: 'text-align', getter: getCssPropertyByName, setters: [setCssProperty] }],
                  ...getTextAlignFieldConfig(TextAlignValueEnum.CENTER),
                },
                {
                  label: 'templateBuilder.fields.spaceBetweenChars',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [{ name: 'letter-spacing', getter: getCssPropertyByName, setters: [setCssProperty] }],
                  ...getStepperFieldConfig(StepperSignEnum.PX),
                },
                {
                  label: 'templateBuilder.fields.internalMargins',
                  selector: '{SELECTOR} .spm_generate_voucher_button a.spm_button, {SELECTOR} .spm_generate_voucher_button a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button a.spm_button:visited, {SELECTOR} .spm_generate_voucher_button a.spm_button:hover',
                  properties: [
                    { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'padding-right', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                  ],
                  componentName: ComponentNameEnum.SPACES,
                  options: {
                    ...getVerticalSpacesFieldConfig('padding').options,
                    ...getHorizontalSpacesFieldConfig('padding').options,
                  },
                },
                {
                  label: 'templateBuilder.fields.mediaDisplay',
                  selector: '{SELECTOR} ',
                  properties: [{ name: 'show-for-', getter: getClassByName, setters: [setMediaDisplay] }],
                  disableHandler: (selector: string) => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true'
                    || isMediaDisplayAlreadyRestricted(selector),
                  disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
                  ...mediaDisplayFieldConfig,
                },
              ],
            },
            {
              type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
              label: 'templateBuilder.configs.voucherCodeStyles',
              selector: 'body #spm_body #spm_content #{ID}',
              items: [
                {
                  label: 'templateBuilder.fields.iconColor',
                  selector: '{SELECTOR} .spm_container_voucher_code .spm_voucher_icon_code',
                  properties: [{ name: 'color', getter: getCssPropertyByName, setters: [setCssPropertyWithImportant] }],
                  ...getColorFieldConfig('#333333'),
                },
                {
                  label: 'templateBuilder.fields.borders',
                  selector: '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [
                    { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                    { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                    { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
                  ],
                  ...bordersFieldConfig,
                },
                {
                  label: 'templateBuilder.fields.backgroundColor',
                  selector: '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [{
                    name: 'background',
                    getter: getCssPropertyByName,
                    setters: [setCssProperty],
                  }],
                  ...getColorFieldConfig('#ECECEC', false, true),
                },
                {
                  label: 'templateBuilder.fields.codeColor',
                  selector: '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [{ name: 'color', getter: getCssPropertyByName, setters: [setCssPropertyWithImportant] }],
                  ...getColorFieldConfig('#000000'),
                },
                {
                  label: 'templateBuilder.fields.codeFontSize',
                  selector: '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [{ name: 'font-size', getter: getCssPropertyByName, setters: [setCssProperty] }],
                  ...fontSizeFieldConfig,
                  options: {
                    ...fontSizeFieldConfig.options,
                    px: {
                      ...fontSizeFieldConfig.options.px,
                      defaultValue: 18,
                    },
                  },
                },
                {
                  label: 'templateBuilder.fields.codeStyles',
                  selector: '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:active, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:visited, '
                    + '{SELECTOR} .spm_generate_voucher_button .spm_container_voucher_code a.spm_button:hover',
                  properties: [
                    { name: 'font-weight', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'font-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-decoration-line', getter: getCssPropertyByName, setters: [setCssProperty] },
                    { name: 'text-transform', getter: getCssPropertyByName, setters: [setCssProperty] },
                  ],
                  ...textStylesFieldConfig,
                },
              ],
            },
          ],
        },
      },
    ],
  },
};

export default widgetVoucherConfig;
